export default class BrandingUrlsModel {
  public primaryUrl: string = null;
  public secondaryUrl: string = null;
  public privacyPolicyUrl: string = null;
  public termsAndConditionsUrl: string = null;
  public additionalUrl: string = null;
}
